import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { navigationRoutes, technicalRoutes } from './routes.js';

function getNestedProperty(obj, path) {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((current, key) => current?.[key], obj);
}

export const RouteRenderer = ({ config, features, isAuthenticated }) => {
  console.log('config', config);
  if (isAuthenticated === null) {
    return (
      <div
        role="status"
        aria-live="polite"
        className="tw-flex tw-items-center tw-justify-center tw-h-full"
      >
        Chargement...
      </div>
    );
  }

  const renderNavigationRoutes = () => {
    return navigationRoutes.flatMap((section) =>
      section.routes
        .filter((route) => {
          if (section.config_required && !config?.[section.config_required])
            return false;

          if (
            route.client_id_required &&
            config?.client_id !== route.client_id_required
          )
            return false;

          if (route.feature_path) {
            const featureValue = getNestedProperty(
              features,
              route.feature_path
            );
            return featureValue === true;
          }

          return true;
        })
        .map((route) => {
          const routesToCreate = [
            <Route
              key={route.url_path}
              path={route.url_path}
              element={<route.component />}
            />,
          ];

          if (route.subsections) {
            route.subsections.forEach((subsection) => {
              routesToCreate.push(
                <Route
                  key={subsection.url_path}
                  path={subsection.url_path}
                  element={<subsection.component />}
                />
              );
            });
          }

          return routesToCreate;
        })
    );
  };

  const renderTechnicalRoutes = () => {
    return technicalRoutes.map((route) => (
      <Route
        key={route.url_path}
        path={route.url_path}
        element={
          !isAuthenticated && !route.public ? (
            <Navigate to="/login" />
          ) : (
            <route.component />
          )
        }
      />
    ));
  };

  return (
    <Routes>
      {isAuthenticated ? renderNavigationRoutes() : null}
      {renderTechnicalRoutes()}
      <Route
        path="*"
        element={
          isAuthenticated ? <Navigate to="/" /> : <Navigate to="/login" />
        }
      />
    </Routes>
  );
};
